import { render } from "./ruledistribute.vue?vue&type=template&id=34d3e8a1&scoped=true"
import script from "./ruledistribute.vue?vue&type=script&lang=js"
export * from "./ruledistribute.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d3e8a1"]])

export default __exports__